import {
  createUserPlanPlanCreateLessonIdGetQueryKey,
  updateUserPlanSectionPlanSubmitSectionPostMutation,
} from '@/client/@tanstack/react-query.gen'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { logger } from '@/utils'
import { useAuthHeaders } from '@/providers'

const log = logger.child({
  file: 'src/hooks/mutations/useUpdateLessonPlanStageMutation.tsx',
})

export type useUpdateLessonPlanStageMutationProps = { lessonId: string }

export const useUpdateLessonPlanStageMutation = ({
  lessonId,
}: useUpdateLessonPlanStageMutationProps) => {
  const headers = useAuthHeaders()
  const queryClient = useQueryClient()
  return useMutation({
    ...updateUserPlanSectionPlanSubmitSectionPostMutation({ headers }),
    onSuccess: async (body) => {
      log.info({ msg: 'Stage updated successfully', data: { body } })
      // invalidate userLessonPlan query to get the latest data
      await queryClient.invalidateQueries({
        queryKey: createUserPlanPlanCreateLessonIdGetQueryKey({
          path: { lesson_id: lessonId },
        }),
      })
    },
    onError: (error) => {
      log.error({ msg: 'Error updating stage', data: { error } })
    },
  })
}
